<template>
	
  <div class="home">
	 <Bar />
   <div class="home-ct">
<div class="login">
	<div class="login-r1" v-if="jin">
	<div class="re-tit">
	
		
		<p>密码丢了？请输入您的用户名或电子邮件地址。您将收到一个通过电子邮件创建新密码的链接。</p>
	</div>

	<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  label-position="top" class="demo-ruleForm" size="mini">
	
	

	  <el-form-item label="郵箱" prop="email">
	    <el-input v-model="ruleForm.email"></el-input>
	  </el-form-item>
	
	<div class="h-button" @click="submitForm('ruleForm')">重置密碼</div>
	  </el-form-item>
	</el-form>
	</div>
	<div class="login-r1" v-else>
	<div class="re-tit">

		
		<p>密码丢了？请输入您的用户名或电子邮件地址。您将收到一个通过电子邮件创建新密码的链接。</p>
	</div>
	
	<el-form :model="form" :rules="rule" ref="form" label-width="100px"  label-position="top" class="demo-ruleForm" size="mini">
	
	
	
	  <el-form-item label="驗證碼" prop="code">
	    <el-input v-model="form.code"></el-input>
	  </el-form-item>
	  <el-form-item label="密碼" prop="pass">
	    <el-input v-model="form.pass"></el-input>
	  </el-form-item>
	
	<div class="h-button" @click="submit('form')">重置密碼</div>
	  </el-form-item>
	</el-form>
	</div>

	<div class="clear"></div>
</div>
   </div>
   <Sim />
   <Place />
    </div>
</template>
<script>

import Bar from '@/components/bar/bar'
import Place from '@/components/place/place'
import Sim from '@/components/sim/sim'

export default {
  components: {

	Bar,Place,Sim
  },
  data() {
    return {
		jin:true,
            ruleForm: {
				email:''
			
			
                  },  form: {
				email:'',
				code:'',
				pass:''
			
			
                  },
                  rules: {
					
					email: [
					    { required: true, message: '請輸入郵箱', trigger: 'blur' },
				]
                 
                  }, rule: {
					
					code: [
					    { required: true, message: '請輸入驗證碼', trigger: 'blur' },
				],pass: [
					    { required: true, message: '請輸入密碼', trigger: 'blur' },
				]
                 
                  }
          };
  },  mounted() {
	  this.id = this.$route.query.id

		this.sandMate();
		this.sandCase();
		},methods: {
			
		 submitForm(formName) {
			
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=users_retrieveCode",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
					
			
		     this.$alert(data.message, 'Prompt', {
		              confirmButtonText: 'Determine',
		              callback: action => {
		              this.jin=false
					  this.form.email=this.ruleForm.email
		              }
		            });
		         		
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      }, submit(formName) {
			
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=users_retrievePass",
		           data: this.form,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
					
			
		     this.$alert(data.message, 'Prompt', {
		              confirmButtonText: 'Determine',
		              callback: action => {
		             this.$router.push({ path: "/login" });	
		              }
		            });
		         		
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
		
			padding: 0 50px;
			height: 50px;
			line-height: 50px;
			background: #000;
			color: #FFFFFF;
			margin-top: 30px;
		
		}
		.h-button:hover{
			background-color: #333333;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 30px;
			font-size: 14px;
			h4{
				font-size: 26px;
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{
	width:500px;
	margin: 0 auto;
	padding: 50px;
	
}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
</style>